import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#6BA52C',
            contrastText: '#FFFFFF'
        },
        text: {
            primary: '#000000',
            secondary: '#FFFFFF'
        },
    },
    components: {
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: '#000', // Default color for input labels when unfocused
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    fontWeight: 700, 
                    borderRadius: 8, 
                    paddingTop: 12,
                    paddingBottom: 12,
                },
            },
        },
    },
    typography:
    {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeightLight: 400
    }
});

export default theme;